import TWEEN from '@tweenjs/tween.js'
import { playSfx, loadAllSfx } from './sfx.js'
import { loadMusic, pauseTrack, resumeTrack, playTrack, stopTrack } from './music.js'
import tileset from './tileset.json'
import { loadAllImages, drawImage, getContext, setContext, getImage } from './images.js'
import { GetLevel, GetSpawns } from './levels.js'
import PlayerInstance from './player.js'
import Particle from './particle.js'

import Enemy from './enemy.js'
import Toad from './toad.js'
import KingSlime from './kingslime.js'

import * as menuCharacterSelect from './menuCharacterSelect.js'
import * as scenes from './sceneController.js'

import Animation from './animation.js'
import { AnimationFrame as LevelUpFrame, Start as LevelUpStart, HandleInput as LevelUpInput } from './level-up.js'
// import { DeathStats } from './scene-youlost.js'
// import { WinStats } from './scene-youwon.js'
// import * as SFX from './sfx.js'
// import { PlayTrack, StopTrack } from './music.js'

var reviveAnimation = new Animation('ressurect-beam')
reviveAnimation.AddListener('frame', 5, (animation) => {
    settings.screenShakeValue = randomJitter(0.6, 1.3)
    playSfx('rumble')
})

var imu = null
var uicanvas = null
var ctx = null
var currentLevel = null
var player = new PlayerInstance(128, 128)
var enemies = []
var gems = []
var particles = []
var damageText = []
var paused = false
var levelTimer = 0
var elapsed = 0
var spawnTimer = 0
var currentTrack = ''
var kills = 0

var transitionAmt = 0

var state = 'transition-in'

var settings = {}

function ui() {
    return imu
}

function addGem(x, y) {
    gems.push({ x: x, y: y, type: 'xp-gem'})
}

function ResetMain() {
    kills = 0
    levelTimer = 0
    elapsed = 0
    player = new PlayerInstance(128, 200)
    settings = {
        screenShakeValue: 0,
        screenShakeDecrementor: 0.03,
        screenShakeFactor: 2,
        levelNumber: 1,
    }
}

/**
 * From https://blog.jakelee.co.uk/converting-levels-into-xp-vice-versa/
 * @param {number} level 
 * @returns 
 */
function LevelXP(level) {
    let x = 0.6
    let y = 2
    return Math.round(Math.pow(level/x, y)) - Math.round(Math.pow((level - 1)/x, y))
}

function IncrementLevel() {
    levelNumber = levelNumber + 1
    return levelNumber
}

/**
 * Returns any tiles of type connecting to the tile at x,y
 * @param {number} x 
 * @param {number} y 
 * @param {string} type 
 * @param {array} tiles (Optional) Used for recursion.
 * @returns 
 */
function getConnectedTiles(x, y, type, tiles) {
    tiles = tiles === undefined ? [] : tiles
    if (x < 0 || x >= currentLevel.width || y < 0 || y >= currentLevel.height || tiles.filter(f => f.x === x && f.y === y).length > 0) {
        return tiles
    }
    let index = CoordinatesToTileIndex(x, y)
    let tileIndex1 = currentLevel.layers[1].data[index] - 1
    let layer1Tile = tileset.tiles.filter(f => f.id === tileIndex1)
    let tileIndex2 = currentLevel.layers[2].data[index] - 1
    let layer2Tile = tileset.tiles.filter(f => f.id === tileIndex2)
    if ((layer1Tile.length > 0 && layer1Tile[0].class === type) || (layer2Tile.length > 0 && layer2Tile[0].class === type)) {
        if (layer1Tile.length > 0 && layer1Tile[0].class === type) {
            tiles.push({ x: x, y: y, index: index, tileIndex: tileIndex1, layerIndex: 1 })
        }
        if (layer2Tile.length > 0 && layer2Tile[0].class === type) {
            tiles.push({ x: x, y: y, index: index, tileIndex: tileIndex2, layerIndex: 2 })
        }
        getConnectedTiles(x, y - 1, type, tiles)
        getConnectedTiles(x, y + 1, type, tiles)
        getConnectedTiles(x - 1, y, type, tiles)
        getConnectedTiles(x + 1, y, type, tiles)
    } else {
        tiles.push({ x: x, y: y })
    }
    return tiles.filter(f => f.index !== undefined)
}

function removeGem(gem) {
    let gemIndex = gems.findIndex(f => f === gem)
    if (gemIndex >= 0) {
        gems[gemIndex] = undefined
    }
    return gem
}

function removeParticle(particle) {
    let partIndex = particles.findIndex(f => f === particle)
    if (partIndex >= 0) {
        particles[partIndex] = undefined
    }
    return particle
}

function removeDamageText(index) {
    try {
        damageText[index] = undefined
    } catch {}
}

function addDamageText(damage, x, y, colr, fnt) {
    let txt = damage
    if (typeof damage === 'number') {
        txt = parseInt(damage)
    }
    colr = colr ? colr : '#f1f1f1ff'
    fnt = fnt ? fnt : font
    damageText.push({ text: `${txt}`, x: x, y: y, elapsed: 0, color: colr, font: fnt })
}

function addParticle(image, x, y, velocityX, velocityY, composition, onDestroy, onUpdate) {
    let particle = new Particle(image, x, y, velocityX, velocityY, composition, (p) => {
        if (onDestroy) {
            onDestroy(p)
        }
        removeParticle(p)
    }, onUpdate)
    particle.destroyNonMoving = false
    particles.push(particle)
    return particle
}

/**
 * Do rectangles specified in paramters intersect?
 * https://stackoverflow.com/questions/16005136/how-do-i-see-if-two-rectangles-intersect-in-javascript-or-pseudocode
 * @param {number} minAx 
 number @param {number} minAy 
 number @param {number} maxAx 
 number @param {number} maxAy 
 number @param {number} minBx 
 number @param {number} minBy 
 number @param {number} maxBx 
 number @param {number} maxBy 
 * @returns {boolean}
 */
function rectanglesIntersect(minAx, minAy, maxAx, maxAy, minBx, minBy, maxBx, maxBy ) {
    let aLeftOfB = maxAx < minBx;
    let aRightOfB = minAx > maxBx;
    let aAboveB = minAy > maxBy;
    let aBelowB = maxAy < minBy;

    // Uncomment to show collision rects.
    // let o = getOrigin()
    // ctx.strokeStyle = '#ffff00'
    // ctx.strokeRect(minAx + o.x, minAy + o.y, maxAx - minAx, maxAy - minAy)
    // ctx.strokeStyle = '#00ffff'
    // ctx.strokeRect(minBx + o.x, minBy + o.y, maxBx - minBx, maxBy - minBy)

    return !( aLeftOfB || aRightOfB || aAboveB || aBelowB );
}

function PlayerCollidesWithEnemies() {
    let rect = { x: parseInt(player.x) - 4, y: parseInt(player.y) + 2, w: player.w - 4, h: player.h - 6 }
    return enemies.filter(f => f.state === 'Idle')
                .map(enemy => rectanglesIntersect(enemy.x - (enemy.w / 2) * 0.8, enemy.y, enemy.x + (enemy.w / 2) * 0.8, enemy.y + (enemy.h / 2) * 0.8, rect.x, rect.y, rect.x + rect.w, rect.y + rect.h)
                                    ? enemy : undefined).filter(f => f !== undefined)
}

/**
 * Return all tiles the rect is colliding with on the layer index..
* @param {object} rect 
* @param {number} layerIndex 
* @returns {boolean}
 */
function CollidesWithLayer(rect, layerIndex) {
    if (!currentLevel || !tileset || !currentLevel.layers[layerIndex]) {
        return false
    }
    let tileRects = []
    let dx = 0
    let dy = 0
    currentLevel.layers[layerIndex].data.forEach((datum) => {
        if (datum > 0) {
            let tiles = tileset.tiles.filter(f => f.id === datum - 1)
            let tile = null
            try { tile = tiles[0] } catch {}
            tileRects.push({ x: dx, y: dy, w: tileset.tilewidth, h: tileset.tileheight, properties: tile && tile.properties ? tile.properties : [] })
        }
        dx += tileset.tilewidth
        if (dx >= tileset.tilewidth * currentLevel.layers[layerIndex].width) {
            dx = 0
            dy += tileset.tileheight
        }
    })
    // tileRects.forEach(m => { if (m.properties.length > 0) { console.log(m.properties, m)} })
    return tileRects.map(m => 
        rectanglesIntersect(m.x, m.y, m.x + m.w, m.y + m.h, rect.x, rect.y, rect.x + rect.w, rect.y + rect.h)
        && m.properties.filter(f => f.name === 'Passable' && f.value === 'true').length === 0
    ).filter(f => f === true).length > 0
}

function randomJitter(min, max) {
    return Math.random() * (max - min) + min
}

function ShadowText(x, y, text, font, fgcolor, shadowColor, bgColr) {
    if (!ctx) {
        ctx = getContext()
    }
    fgcolor = fgcolor !== undefined ? fgcolor : '#f1f1f1ff'
    shadowColor = shadowColor !== undefined ? shadowColor : '#000000c0'
    let effects = bgColr !== undefined ? { background: { colour: bgColr } } : {}
    bfontjs.DrawText(ctx, x, y + 1, text, shadowColor, font, effects)
    bfontjs.DrawText(ctx, x, y, text, fgcolor, font, effects)
}

function HandleInput(input, amt, released) {
    if (state === 'gameplay') {
        if (player.dead || player.state === 'Death') {
            return
        }
        
        if (input === 'right') {
            player.movement.x = amt
            player.flipped = true
        } else if (input === 'left') {
            player.movement.x = -amt
            player.flipped = false
        } else if (input === 'up') {
            player.movement.y = -amt
        } else if (input === 'down') {
            player.movement.y = amt
        } else if (input === 'cancel') {
            paused = true
            if (released) {
                playSfx('pause')
                pauseTrack(currentTrack)
                state = 'gamemenu'
            }
        }
    } else if (state === 'level-up') {
        LevelUpInput(input, amt)
    } else if (state === 'gamemenu') {
        if (input === 'cancel' && released) {
            paused = false
            state = 'gameplay'
            resumeTrack(currentTrack)
            console.log('resume', currentTrack)
        }
    }
}


function spawnEnemyParticles(particleName, x, y) {
    function spawnUpdate(p, delta) {
        if (p.elapsed > 200) {
            p.Destroy()
        }
        // Simulate Gravity.
        p.movement.y += 0.001 * delta
    }

    let angle = player.AngleBetween(x, y)
    let velX = Math.cos(angle) * 0.05
    let velY = Math.sin(angle) * 0.05

    for (let n = 0; n < 8; n++) {
        let sx = x + randomJitter(-2, 2)
        let sy = y + randomJitter(-2, 2)

        setTimeout(() => {
            let p1 = addParticle(particleName, sx, sy, 0.015 * randomJitter(0.1, 0.9), -0.15 * randomJitter(0.7, 1), 'source-over', undefined, spawnUpdate)
            p1.friction = 0.01
            p1.movement.x -= velX
            p1.movement.y -= velY 
            p1.w = 4
            p1.h = 4
            let p2 = addParticle(particleName, sx, sy, 0 + randomJitter(-0.05, 0.05), -0.15 * randomJitter(0.9, 1), 'source-over', undefined, spawnUpdate)
            p2.friction = 0.01
            p2.movement.x -= velX
            p2.movement.y -= velY 
            p2.w = 4
            p2.h = 4
            let p3 = addParticle(particleName, sx, sy, -0.015 * randomJitter(0.1, 0.9), -0.15 * randomJitter(0.7, 1), 'source-over', undefined, spawnUpdate)
            p3.friction = 0.01
            p3.movement.x -= velX
            p3.movement.y -= velY 
            p3.w = 4
            p3.h = 4
        }, 30 * n)
    }
}

function spawnGemParticles(particleName, x, y) {
    function spawnUpdate(p, delta) {
        if (p.elapsed > 800) {
            p.Destroy()
        }
        // Simulate Gravity.
        //p.movement.y += 0.001 * delta
        p.x = x + Math.sin(p.y) * 0.15 * delta
        p.opacity = 1 - p.elapsed / 800
    }

    // let angle = player.AngleBetween(x, y)
    // let velX = Math.cos(angle) * 0.05
    // let velY = Math.sin(angle) * 0.05
    let speed = 0.01

    for (let n = 0; n < 6; n++) {
        let sx = x + randomJitter(-2, 2)
        let sy = y + randomJitter(-2, 2)

        setTimeout(() => {
            let p1 = addParticle(particleName, sx, sy, 0, 0, 'lighten', undefined, spawnUpdate)
            p1.friction = 0.001
            p1.x = sx - 2
            p1.movement.y -= speed * 2
            p1.w = 4
            p1.h = 4
            let p2 = addParticle(particleName, sx, sy, 0, 0, 'lighten', undefined, spawnUpdate)
            p2.friction = 0.001
            p2.x = sx + 2
            p2.movement.y -= speed * 2
            p2.w = 4
            p2.h = 4
            let p3 = addParticle(particleName, sx, sy, 0, 0, 'lighten', undefined, spawnUpdate)
            p3.friction = 0.001
            p3.movement.y -= speed * 2
            p3.w = 4
            p3.h = 4
        }, 60 * n)
    }
}


function spawnBloodParticles() {
    function spawnUpdate(p, delta) {
        if (p.elapsed > 200) {
            p.Destroy()
        }
        // Simulate Gravity.
        p.movement.y += 0.001 * delta
    }

    for (let n = 0; n < 8; n++) {        
        setTimeout(() => {
            let sx = player.x + randomJitter(-2, 2)
            let sy = player.y + randomJitter(-2, 2)

            let p1 = addParticle('Blood-Particle', sx, sy, 0.125 * randomJitter(0.1, 0.9), -0.1, undefined, undefined, spawnUpdate)
            p1.friction = 0.15
            p1.w = 4
            p1.h = 4
            let p2 = addParticle('Blood-Particle', sx, sy, 0 + randomJitter(-0.05, 0.05), -0.1, undefined, undefined, spawnUpdate)
            p2.friction = 0.15
            p2.w = 4
            p2.h = 4
            let p3 = addParticle('Blood-Particle', sx, sy, -0.125 * randomJitter(0.1, 0.9), -0.1, undefined, undefined, spawnUpdate)
            p3.friction = 0.15
            p3.w = 4
            p3.h = 4
        }, 10 * n)
    }
}

function getGameplayEdges() {
    let left = player.x - parseInt(uicanvas.width / 2)
    let top = player.y - parseInt(uicanvas.height / 2)
    if (top < 64) {
        top = 64
    }
    if (left < 0) {
        left = 0
    }
    let right = player.x + parseInt(uicanvas.width / 2)
    let bottom = player.y + parseInt(uicanvas.height / 2)
    if (right > tileset.tilewidth * currentLevel.width) {
        right = tileset.tilewidth * currentLevel.width
    }
    if (bottom > tileset.tileheight * currentLevel.height - 24) {
        bottom = tileset.tileheight * currentLevel.height - 24
    }

    return { left: parseInt(left), top: parseInt(top), right: parseInt(right), bottom: parseInt(bottom) }
}

/**
 * Gets called once every requestAnimationFrame by the browser.
 */
function AnimationFrame(delta) {
    // Get rid of any destroyed (IE: undefined) particles.
    particles = particles.filter(f => f)

    enemies.filter(f => f.dead).forEach(enemy => {
        for (let i = 0; i < enemy.xp; i++) {
            addGem(enemy.x - 4 + randomJitter(-4, 4), enemy.y - 2 + randomJitter(-4, 4))
        }
        kills++
        spawnEnemyParticles(enemy.particleImage, enemy.x, enemy.y)
        if (enemy.character === 'BigSlime') {
            let slime1 = spawnEnemy(['slime'])
            slime1.x = enemy.x + randomJitter(-8, -4)
            slime1.y = enemy.y + randomJitter(-4, 4)
            slime1.SetAnimation('Hurt')
            let slime2 = spawnEnemy(['slime'])
            slime2.x = enemy.x + randomJitter(4, 8)
            slime2.y = enemy.y + randomJitter(-4, 4)
            slime2.SetAnimation('Hurt')
        }     
    })
    enemies = enemies.filter(f => !f.dead)

    //ctx.clearRect(0, 0, uicanvas.width, uicanvas.height)
    ctx.fillStyle = '#293268'
    ctx.fillRect(0, 0, uicanvas.width, uicanvas.height)
    drawImage('sky', 0, 0)
    let px = player.x
    let py = player.y - 58
    if (px < 120) {
        px = 120
    }
    if (px > currentLevel.width * tileset.tilewidth - 120) {
        px = currentLevel.width * tileset.tilewidth - 120
    }
    if (py > 70) {
        py = 70
    }
    
    let parallaxHillsX = parseInt(((1 - px / 480) * 220 * 0.25) - 220)
    let parallaxHillsY = parseInt(((py / 200) * 64 * 0.25)) - 6
    parallaxHillsY = parallaxHillsY > -4 ? -4 - (player.y - 98) : parallaxHillsY
    
    if (parallaxHillsY < -38) {
        parallaxHillsY = -38
    }
    drawImage('hills', parseInt(parallaxHillsX), parseInt(parallaxHillsY))
    let parallaxNearHillsX = parseInt(((1 - px / 480) * 220 * 0.5) - 220)
    let parallaxNearHillsY = parseInt(((py / 100) * 64 * 0.25) + 8)
    parallaxNearHillsY = parallaxNearHillsY > 11 ? 11 - (player.y - 84) : parallaxNearHillsY

    if (parallaxNearHillsY < -37) {
        parallaxNearHillsY = -37
    }   
    drawImage('near-hills', parseInt(parallaxNearHillsX), parseInt(parallaxNearHillsY))

    if (settings.screenShakeValue > 0) {
        ctx.resetTransform()
        ctx.translate(
            Math.floor(randomJitter(-settings.screenShakeValue * settings.screenShakeFactor, settings.screenShakeValue * settings.screenShakeFactor)), 
            Math.floor(randomJitter(-settings.screenShakeValue * settings.screenShakeFactor, settings.screenShakeValue * settings.screenShakeFactor))
        )
    }

    DrawLevel(delta)  
    particles = particles.filter(f => f !== undefined)
    
    elapsed += delta

    console.log('currentTrack', currentTrack)

    if (!paused && state === 'gameplay') {
        if (!isNaN(delta)) {
            levelTimer += delta
        }
    
        player.Update(delta)
        if (player.state !== 'Hurt' && !player.dead) {                
            // After collisions are sorted highest to lowest by damage, apply the 
            // first enemy's damage to the player.
            let collisions = PlayerCollidesWithEnemies().sort((a, b) => a.damage - b.damage)
            if (collisions.length) {
                let dmg = Math.ceil(collisions[0].damage * delta)
                player.Damage(dmg)
                playSfx('playerhurt')
                addDamageText(dmg, player.x, player.y, '#f10000ff')
            }
        } else if (player.dead && player.state === 'Death' && player.substate === '' && player.revives > 0) {
            player.substate = 'revivifying'
            reviveAnimation.PlayFromStart()
            reviveAnimation.listeners.ended = () => {
                reviveAnimation.listeners.ended = () => {}
                setTimeout(() => {
                    player.revives--
                    player.dead = false
                    player.substate = ''
                    addDamageText('REVIVED!', player.x - 15, player.y - 5, '#42bc7fff', eighties)
                    spawnGemParticles('Gem-Particle', player.x + randomJitter(-4, 4), player.y + randomJitter(-4, 4))
                    spawnGemParticles('Gem-Particle', player.x + randomJitter(-4, 4), player.y + randomJitter(-4, 4))
                    spawnGemParticles('Gem-Particle', player.x + randomJitter(-4, 4), player.y + randomJitter(-4, 4))
                    playSfx('revive')
                    player.SetAnimation('Hurt')
                    player.hp = player.maxHp
                }, 1300)
            }
        }
        
        if (player.substate === 'revivifying') {
            reviveAnimation.Update(delta)
            reviveAnimation.Draw(45, 0)
        }

        if (player.x < 0) {
            player.x = 0
        }
        if (player.y <= 58) {
            player.y = 58
        }
        if (player.x >= currentLevel.width * tileset.tilewidth) {
            player.x = currentLevel.width * tileset.tilewidth
        }
        if (player.y >= currentLevel.height * tileset.tileheight - 24) {
            player.y = currentLevel.height * tileset.tileheight - 24
        }

        if (levelTimer > spawnTimer) {
            let spawns = GetSpawns(currentLevel.name, levelTimer)
            if (spawns.length > 0) {
                let spawn = spawns[randomIntRange(0, spawns.length - 1)]
                if (spawn.maxEnemyCount > enemies.length) {
                    spawnEnemy(spawn)
                    if(spawn.music && currentTrack !== spawn.music) {
                        stopTrack(currentTrack)
                        playTrack(spawn.music)
                        currentTrack = spawn.music
                        console.log('set currentTrack', currentTrack)
                    }
                }
                spawnTimer = levelTimer + spawn.spawnDelay
            }
        }
    } else if (state === 'transition-in') {
        let ga = ctx.globalAlpha
        let amt = 1 - elapsed / 300
        if (amt <= 0) {
            state = 'gameplay'
        } else {
            ctx.globalAlpha = amt
            ctx.fillStyle = '#000000'
            ctx.fillRect(0, 0, 200, 187)
            ctx.globalAlpha = ga
        }
    }

    settings.screenShakeValue -= delta * settings.screenShakeDecrementor
    if (settings.screenShakeValue < 0) {
        settings.screenShakeValue = 0
        ctx.resetTransform()
    }

    let ox = getOrigin().x 
    let oy = getOrigin().y

    if (player.stats.active.area > 0 && player.stats.level.area > 0) {
        ctx.strokeStyle = '#c1d9f2ff'
        ctx.beginPath()
        ctx.lineWidth = 2
        let ga = ctx.globalAlpha
        let op = ctx.globalCompositeOperation
        ctx.globalAlpha = 0.3
        ctx.globalCompositeOperation = 'lighten'
        let offset = parseInt((levelTimer % 300) * 0.008)
        ctx.arc(player.x + ox, player.y + oy + 4, player.stats.damage.range.area - offset + offset / 2, 0, 360)
        //ctx.setLineDash([2, 2])
        ctx.stroke()
        ctx.globalAlpha = ga
        ctx.globalCompositeOperation = op
    }

    if (imu !== null) {
        imu.onUpdate = async (ui) => {
            if (state === 'gamemenu') {
                let midy = parseInt(187 / 4 - bfontjs.Fonts('default').cheight / 2) - 16
                let rect = { x: 40, y: midy + 15, w: 120, h: 136 }

                let frame = imu.Element({ id: 'frameImage', type: 'FrameImage', image: getImage('uiframe'), rect: rect, borderWidth: 4 })
            }
            //ui.Element({ id: 'id', text: `${parseInt(player.x)},${parseInt(player.y)}`.toUpperCase(), x: 4, y: 4, color: '#f1f1f1ff', highlight: '#ffffffff', font: font })
            //ui.Element({ id: 'hp', text: `${parseInt(player.hp)} / ${parseInt(player.maxHp)}`.toUpperCase(), x: 20, y: 6, color: '#f1f1f1ff', highlight: '#ffffffff', font: font,  })
            //ui.Element({ id: 'cooldown', text: `${parseInt(enemies.length)}`, x: 3, y: 16, color: '#f1f1f1ff', highlight: '#ffffffff', font: font,  })
        }
        imu.Draw()

    } else {
        imu = new imui.ImUI(uicanvas)
    }

    damageText.forEach((damage, index) => {
        bfontjs.DrawText(ctx, parseInt(damage.x + ox), parseInt(damage.y + 1 + oy), damage.text, '#090909d9', damage.font)
        damage.elapsed += delta
        damage.y -= delta * 0.01
        let colr = damage.color
        bfontjs.DrawText(ctx, parseInt(damage.x + ox), parseInt(damage.y + oy), damage.text, colr, damage.font)
        if (damage.elapsed > 600) {
            removeDamageText(index)
        }
    })
    damageText = damageText.filter(f => f)

    // Clear any gems that are close enough to the player.
    gems.filter(f => Math.sqrt( Math.pow((player.x - f.x), 2) + Math.pow((player.y - f.y), 2) ) <= player.stats.gemCollect.pickupRange)
        .forEach(gem => {
            let sfx = ['gem', 'gem2', 'gem3'][randomIntRange(0, 2)]
            playSfx(sfx)
            spawnGemParticles('Gem-Particle', gem.x, gem.y)
            removeGem(gem)
            player.xp += player.stats.gemCollect.xpfactor
            if (player.xp >= player.maxXp) {
                paused = true
                state = 'level-up'
                pauseTrack(currentTrack)
                console.log('pause', currentTrack)
                LevelUpStart((upgrade) => {
                    player.ApplyUpgrade(upgrade)
                    resumeTrack(currentTrack)
                    console.log('unpause', currentTrack)
                    state = 'gameplay'
                    paused = false
                    player.movement = { x: 0, y: 0 }
                    player.xp -= player.maxXp
                    player.level++
                    player.maxXp = LevelXP(player.level) 
                })
            }
        })
    gems = gems.filter(f => f)

    if (state === 'gamemenu') {
        let midx = 100 - parseInt(bfontjs.CalculateTextWidth('PAUSED', bfontjs.Fonts('default')) / 2)
        let midy = parseInt(187 / 4 - bfontjs.Fonts('default').cheight / 2) - 16
        bfontjs.DrawText(ctx, midx, midy, `PAUSED`, '#090909d9')
        bfontjs.DrawText(ctx, midx, midy - 1, `PAUSED`, '#f1f1f1ff')
        let rect = { x: 40, y: midy + 15, w: 120, h: 136 }

        // let ga = ctx.globalAlpha
        // ctx.globalAlpha = 0.9
        // ctx.fillStyle = '#293268'
        // ctx.fillRect(rect.x, rect.y, rect.w, rect.h)            
        // ctx.globalAlpha = ga

        ShadowText(rect.x + 4, rect.y + 4, `PLAYER STATS     HP: ${player.hp}/${player.maxHp}`, eighties)

        let staty = rect.y + 16
        ShadowText(rect.x + 4, staty, 'Melee Cooldown:' + parseInt(player.stats.cooldown.duration.melee) + 'ms', eighties)
        staty += 10
        ShadowText(rect.x + 4, staty, 'Projectile Cooldown:' + parseInt(player.stats.cooldown.duration.projectile) + 'ms', eighties)
        staty += 10
        ShadowText(rect.x + 4, staty, 'Area Cooldown:' + parseInt(player.stats.cooldown.duration.area) + 'ms', eighties)
        staty += 15

        ShadowText(rect.x + 4, staty, 'Melee Damage:' + parseInt(player.stats.damage.melee * 100) + '%', eighties)
        staty += 10
        ShadowText(rect.x + 4, staty, 'Projectile Damage:' + parseInt(player.stats.damage.projectile * 100) + '%', eighties)
        staty += 10
        ShadowText(rect.x + 4, staty, 'Area Damage:' + parseInt(player.stats.damage.area * 100) + '%', eighties)
        staty += 15

        ShadowText(rect.x + 4, staty, 'Melee Range:' + parseInt(player.stats.damage.range.melee), eighties)
        staty += 10
        ShadowText(rect.x + 4, staty, 'Projectile Range:' + parseInt(player.stats.damage.range.projectile), eighties)
        staty += 10
        ShadowText(rect.x + 4, staty, 'Area Range:' + parseInt(player.stats.damage.range.area), eighties)
        staty += 15
    }

    // Health UI
    drawImage('icon-heart', 3, 3, { x: 0, y: 0, w: 13, h: 14 })
    let iconHeight = parseInt((player.hp / player.maxHp) * 14)
    drawImage('icon-heart', 3, 3, { x: 13, y: 0, w: 13, h: 14 - iconHeight })
    if (player.revives > 0) {
        ShadowText(12, 11, player.revives.toString(), font, '#f1f1f1ff', '#090909d9')
    }
    bfontjs.DrawText(ctx, 20, 7, `${parseInt(Math.ceil(player.hp))} / ${parseInt(player.maxHp)}`, '#090909d9', font)
    bfontjs.DrawText(ctx, 20, 6, `${parseInt(Math.ceil(player.hp))} / ${parseInt(player.maxHp)}`, '#f1f1f1ff', font)

    // XP UI
    let iconWidth = parseInt((player.xp / player.maxXp) * 118)
    drawImage('ui-xpbar-empty', 19, 5)
    drawImage('ui-xpbar-full', 19, 5, { x: 0, y: 0, w: iconWidth, h: 10 })
    bfontjs.DrawText(ctx, 24, 8, `LVL ${player.level}`, '#090909d9', font)
    bfontjs.DrawText(ctx, 24, 7, `LVL ${player.level}`, '#f1f1f1ff', font)

    let time = millisToMinutesAndSeconds(levelTimer)
    bfontjs.DrawText(ctx, 146, 4, time, '#090909d9')
    bfontjs.DrawText(ctx, 146, 3, time, '#f1f1f1ff')

    if (state === 'level-up') {
        LevelUpFrame(delta)
    }

    // Stats UI
    drawImage('Skull', 3, 176)
    ShadowText(13, 178, kills.toString(), font, '#f1f1f1ff', '#090909d9')
}

function millisToMinutesAndSeconds(millis) {
    var minutes = Math.floor(millis / 60000);
    var seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
  }

function randomInt(max) {
  return Math.round(Math.random() * max)
}

function randomIntRange(min, max) {
    return randomInt(max - min) + min
}

function getEnemiesInRange(range) {
    range = range ? range : player.stats.damage.range.melee
    return enemies.filter(f => {
        let enemyw = f.w / 2
        let enemyh = f.h / 2
                
        return Math.sqrt( Math.pow((player.x - f.x - enemyw), 2) + Math.pow((player.y - f.y), 2)) <= range // Top Left Hits
            || Math.sqrt( Math.pow((player.x - f.x + enemyw), 2) + Math.pow((player.y - f.y), 2)) <= range // Top Right Hits
            || Math.sqrt( Math.pow((player.x - f.x - enemyw), 2) + Math.pow((player.y - f.y + enemyh), 2)) <= range // Bottom Left Hits
            || Math.sqrt( Math.pow((player.x - f.x + enemyw), 2) + Math.pow((player.y - f.y + enemyh), 2)) <= range // Bottom Right Hits
    })
}

function getGemsInRange() {
    return gems.filter(f => Math.sqrt( Math.pow((player.x - f.x), 2) + Math.pow((player.y - f.y), 2) ) <= player.stats.gemCollect.range)
}

function spawnEnemy(spawn) {
    if (Array.isArray(spawn)) {
        spawn = {
            enemies: spawn
        }
    }
    try {
        let enemy = spawn.enemies[randomIntRange(0, spawn.enemies.length - 1)]

        let edges = getGameplayEdges()
        let side = ['left', 'top', 'bottom', 'right'][randomInt(3)]
        let sx = 0
        let sy = 0

        switch(side) {
            case 'top':
                sy = edges.top
                sx = randomIntRange(edges.left, edges.right)
                break
            case 'left':
                sx = edges.left
                sy = randomIntRange(edges.top, edges.bottom)
                break
            case 'right':
                sx = edges.right
                sy = randomIntRange(edges.top, edges.bottom)
                break
            case 'bottom':
                sy = edges.bottom
                sx = randomIntRange(edges.left, edges.right)
                break
        }
        
        if (enemy === 'slime') {
            let slime = new Enemy(sx, sy)
            enemies.push(slime)
            return slime
        }
        if (enemy === 'bigslime') {
            let slime = new Enemy(sx, sy)
            slime.character = 'BigSlime'
            slime.maxHp = 15
            slime.xp = 2
            slime.hp = slime.maxHp
            slime.w = 20
            slime.h = 24
            slime.damage = 0.2
            slime.speed = 0.05
            enemies.push(slime)
            return slime
        }
        if (enemy === 'bat') {
            let bat = new Enemy(sx, sy)
            bat.character = 'Bat'
            bat.maxHp = 5
            bat.hp = bat.maxHp
            bat.w = 12
            bat.h = 12
            bat.damage = 0.05
            bat.speed = 0.2
            bat.particleImage = 'Blood-Particle'
            enemies.push(bat)
            return bat
        }
        if (enemy === 'toad') {
            let toad = new Toad(sx, sy)
            enemies.push(toad)
            return toad
        }
        if (enemy === 'kingslime') {
            let kingslime = new KingSlime(sx, sy)
            enemies.push(kingslime)
            return kingslime
        }
    } catch (e) { console.error(e) }
    return false
}

/**
 * Get the rect for the tile at tileIndex.
 * @param {number} tileIndex 
 * @returns 
 */
function TileRect(tileIndex) {
    //const colPosition = index % colCount
// const rowPosition = Math.floor( (index - colPosition) / colCount)
// const answer = (rowPosition + 1) * colCount
    let col = tileIndex % tileset.columns
    let row = Math.floor((tileIndex - col) / tileset.columns)
    return {
        x: col * tileset.tileheight, y: row * tileset.tileheight,
        w: tileset.tilewidth, h: tileset.tileheight
    }
}

function CoordinatesToTileIndex(x, y) {
    return (y * currentLevel.width) + x
}

function TileIndexToCoordinates(tileIndex) {
    let col = tileIndex % currentLevel.width
    let row = Math.floor((tileIndex - col) / currentLevel.width)
    return { x: col, y: row }
}

/**
 * Draw tile at index at position specified at x,y
 * @param {string} image 
 * @param {number} tileIndex
 * @param {number} x 
 * @param {number} y 
 */
function DrawTile(image, tileIndex, x, y) {
    let rect = TileRect(tileIndex)
    drawImage(image, x, y, rect)
}

function GetPlayer() {
    return player
}

function MovePlayer(dir, amount) {
    if (dir === 'left') {
        player.movement.x = -speed * amount
    } else if (dir === 'right') {
        player.movement.x = speed * amount
    } else if (dir === 'up') {
        player.movement.y = -speed * amount
    } else if (dir === 'down') {
        player.movement.y = speed * amount
    }
}

function getOrigin() {
    let ox = parseInt(player.x) * -1 + parseInt(uicanvas.width / 2)
    let oy = parseInt(player.y) * -1 + parseInt(uicanvas.height / 2)

    if (ox > 0) {
        ox = 0
    }
    
    if (ox < -currentLevel.width * tileset.tilewidth + parseInt(uicanvas.width)) {
        ox = -currentLevel.width * tileset.tilewidth + parseInt(uicanvas.width)
    }
    
    // if (oy < -37) {
    //     oy = -37
    // }

    return { x: parseInt(ox), y: parseInt(oy) }
}

/**
 * Draws map every frame.
 */
function DrawLevel(deltaTime) {
    let ox = getOrigin().x 
    let oy = getOrigin().y

    if (currentLevel) {
        currentLevel.layers.filter(f => f.visible).forEach((layer, layerIndex) => {
            let dx = 0
            let dy = 0
            // Draw layer tiles.
            layer.data.forEach((tileIndex, index, arr) => {
                if (tileIndex > 0) {
                    DrawTile('tileset', tileIndex - 1, ox + dx, oy + dy)
                }
                
                // If this is the middle layer, draw the player on top of it.
                if (index === arr.length - 1 && layerIndex === 1) {
                    let entities = [player]
                    //player.Draw(ox, oy)

                    enemies.forEach(enm => {
                        if (!paused) {
                            enm.Update(deltaTime)
                        }
                        //enm.Draw(ox, oy)
                        entities.push(enm)
                    })

                    gems.forEach(gem => {
                        entities.push(gem)
                    })

                    // Make sure entities with a bigger y value get rendered
                    // on top of those with a smaller y.
                    entities.sort((a, b) => a.y - b.y).forEach(entity => {
                        if (entity.Draw) {
                            entity.Draw(ox, oy)
                        } else {
                            drawImage(entity.type, parseInt(entity.x + ox), parseInt(entity.y + oy))
                        }
                    })
                } else if (layerIndex === 2) {
                    // Or if it's the top layer draw flame sprites and particles.
                    if (index === arr.length - 1) {
                        particles.forEach(p => {
                            if (p && !paused) {
                                p.Update(deltaTime)
                                p.Draw(ox, oy)
                            }
                        })
                    }
                }
                dx += tileset.tilewidth
                if (dx >= layer.width * tileset.tilewidth) {
                    dx = 0
                    dy += tileset.tileheight
                }
            })
        })
    }
}

function Start() {
    scenes.addScene('game', HandleInput, AnimationFrame, () => {
        ResetMain()
    })
    scenes.activateScene(scenes.addScene('character select', menuCharacterSelect.handleInput, menuCharacterSelect.handleAnimationFrame, menuCharacterSelect.start).id)
    requestAnimationFrame(scenes.handleAnimationFrame)
}

/**
 * Sets up the level layout and sprites according to the theme specified.
 * @param {string} level Level name.
 */
function PrepareLevel(level) {
    currentLevel = GetLevel(level)
    currentLevel.name = level
    console.log(level, currentLevel)

    levelTimer = 0

    console.log('Level loaded:', currentLevel)
}

/**
 * Loads any media we need.
 */
async function LoadMedia(canvas) {
    return new Promise(async (resolve, reject) => {
        uicanvas = canvas
        ctx = canvas.getContext('2d')
        ctx.imageSmoothingEnabled = false
        setContext(ctx)
        await loadAllImages()
        loadMusic()
            .catch((err) => {
                console.log('Error loading track', err)
                reject('Error loading track ' + err.toString())
            })
            .then(() => {
                loadAllSfx()
                    .catch((err) => {
                        console.log('Error loading sfx', err)
                        reject('Error loading sfx ' + err.toString())
                    })
                    .then(() => {
                        console.log('Loaded media.')
                        console.log('Tileset:', tileset)
                        resolve()
                    })
            })
        })
}

export { AnimationFrame, PrepareLevel, LoadMedia, TileRect, DrawTile, 
    DrawLevel, CollidesWithLayer, player, MovePlayer, CoordinatesToTileIndex, enemies,
    tileset, currentLevel, ShadowText, ResetMain, Start, IncrementLevel, settings, HandleInput, PlayerCollidesWithEnemies, getEnemiesInRange as GetEnemiesInRange,
    getGemsInRange as GetGemsInRange, spawnBloodParticles, removeGem, getGameplayEdges, LevelXP, addDamageText, randomIntRange, playTrack as playSong, randomJitter,
    addParticle, rectanglesIntersect, spawnEnemyParticles, currentTrack, scenes, ui,
    GetPlayer }